import { useState } from 'react';
import Reveal from '@/components/base/Reveal';
import { clueTypes } from '@/mocks/home';

function SubmitCta() {
  const [clicked, setClicked] = useState(false);

  return (
    <section id="submit" className="w-full bg-background-100 py-20 md:py-28">
      <div className="max-w-shell mx-auto px-4 md:px-8">
        <Reveal>
          <div className="rounded-lg border border-accent-200 bg-accent-50 p-6 md:p-12">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
              <div className="lg:col-span-5">
                <span className="inline-flex items-center gap-2 text-xs tracking-[0.25em] text-accent-700 font-label">
                  <i className="ri-contacts-book-2-line"></i>
                  TIP LINE
                </span>
                <h2 className="mt-3 font-heading text-3xl md:text-4xl font-bold text-foreground-950">
                  爆料人通道
                </h2>
                <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
                  如果你手里有签约合同、排班记录或私下聊天记录，
                  可以按下面三种形式提交。所有线索默认匿名处理，来源信息不会被公开。
                </p>

                <div className="mt-8 flex flex-col sm:flex-row sm:items-center gap-4">
                  <button
                    type="button"
                    onClick={() => setClicked(true)}
                    className="whitespace-nowrap px-7 py-3.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer"
                  >
                    我要提供线索
                  </button>
                  <span className="text-xs text-foreground-600">
                    已收到 4,502 条线索 · 核实率 92%
                  </span>
                </div>

                {clicked && (
                  <p className="mt-4 text-xs text-primary-700 bg-primary-100 border border-primary-200 rounded-md px-4 py-3">
                    演示页面：线索提交入口尚未开放，你可以先在深挖专区浏览已整理的爆料内容。
                  </p>
                )}
              </div>

              <div className="lg:col-span-7">
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
                  {clueTypes.map((type, index) => (
                    <Reveal key={type.name} delay={index * 80}>
                      <div className="h-full rounded-lg bg-background-50 border border-accent-200/70 p-5 flex flex-col">
                        <span className="w-11 h-11 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center">
                          <i className={`${type.icon} text-xl`}></i>
                        </span>
                        <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">
                          {type.name}
                        </h3>
                        <p className="mt-2 text-xs leading-relaxed text-foreground-600 flex-1">
                          {type.desc}
                        </p>
                      </div>
                    </Reveal>
                  ))}
                </div>

                <div className="mt-5 rounded-lg bg-background-50 border border-accent-200/70 p-5 flex flex-col sm:flex-row sm:items-center gap-4">
                  <span className="w-11 h-11 shrink-0 rounded-md bg-secondary-100 text-secondary-700 flex items-center justify-center">
                    <i className="ri-lock-2-line text-xl"></i>
                  </span>
                  <p className="text-xs leading-relaxed text-foreground-600">
                    提交前可先阅读《线索核实标准》与《隐私保护承诺》，
                    涉及个人隐私的内容我们会做去标识化处理后再整理上线。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export default SubmitCta;